var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToleft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_205_1731)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 27.9518,
    cy: 25.9523,
    r: 20.5479,
    transform: "rotate(179.534 27.9518 25.9523)",
    fill: "white",
    stroke: "#CECECE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8278 29.5147C26.8262 29.3129 26.7578 29.1789 26.6221 29.0454L23.2311 25.7091C22.9598 25.4422 22.5561 25.4455 22.2892 25.7168C22.0223 25.9881 22.0256 26.3917 22.2969 26.6586L25.688 29.9949C25.9593 30.2618 26.3629 30.2585 26.6298 29.9873C26.7633 29.8516 26.8294 29.7165 26.8278 29.5147Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7731 22.7916C26.7714 22.5898 26.7031 22.4558 26.5674 22.3223C26.2961 22.0554 25.8925 22.0587 25.6256 22.33L22.2893 25.7211C22.0224 25.9924 22.0256 26.396 22.2969 26.6629C22.5682 26.9298 22.9719 26.9266 23.2388 26.6553L26.5751 23.2642C26.7085 23.1285 26.7747 22.9934 26.7731 22.7916Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2006 26.0907C34.1973 25.6871 33.926 25.4202 33.5223 25.4235L22.7585 25.5111C22.3549 25.5144 22.0879 25.7857 22.0912 26.1893C22.0945 26.593 22.3658 26.8599 22.7694 26.8566L33.5333 26.769C33.9369 26.7657 34.2038 26.4944 34.2006 26.0907Z",
    fill: "#4F4F4F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_205_1731",
    x: 0.829712,
    y: 0.82959,
    width: 58.3406,
    height: 58.3403,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_205_1731"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_205_1731",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToleft);
export default __webpack_public_path__ + "static/media/toleft.938147d58bfb7d0d53caae0d09cce800.svg";
export { ForwardRef as ReactComponent };